import React, { useEffect, useState } from "react";
import { HashRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { ROUTELIST } from "./routes";
import { Space, Switch, FloatButton, ConfigProvider, Tag, Button, Row, Divider } from 'antd';
import logo from "../media/LOGO.png";

import TestimonialPage from "../pages/Testimonial";
import Profile from "../pages/Profile";
import { Footer } from "antd/es/layout/layout";

import {
    BankOutlined,
    EnvironmentOutlined,
    FacebookFilled,
    InstagramFilled,
    LinkedinFilled,
    MailOutlined,
    PhoneFilled,
    SolutionOutlined,
    ThunderboltOutlined,
    TikTokFilled,
    WhatsAppOutlined,
    XOutlined,
    ClockCircleFilled,
    MenuFoldOutlined,
    MenuOutlined, MenuUnfoldOutlined,
    ClockCircleOutlined,
} from '@ant-design/icons';
import axios from "axios";
import ProjectsDetails from "../pages/ProjectDetails/Index";


const useCSRF = () => {
    useEffect(() => {
        const fetchCSRFToken = async () => {
            try {
                const response = await axios.get("http://localhost:8000/api/csrf", { withCredentials: true });
                console.log("CSRF Token:", response.data.csrfToken);
                localStorage.setItem("csrfToken", response.data.csrfToken);
            } catch (error) {
                console.error("Error fetching CSRF token:", error);
            }
        };

        fetchCSRFToken();
    }, []);
};

const RouterHandler = () => {

    const [isExpanded, setExpanded] = useState(false);
    const [openDiv, setOpenDiv] = useState(null);
    const toggleMenu = () => {
        console.log("Toggled")
        setExpanded(!isExpanded);
    };
    const handleDivClick = (index: any) => {
        setOpenDiv(openDiv === index ? null : index);
        console.log("Index: ", index)
        if(!ROUTELIST[index].children){
            setExpanded(!isExpanded)    
        }
       
    };
    //useCSRF();
    return (
        <div className="app">
            <Router>
                <div className="heading">
                    <div className="navbar">
                        <Link to={"/#"}><img src={logo} alt="logo" width={100}></img></Link>
                        <div className="navbar-links">

                            {ROUTELIST.map((menuitem, i) => (
                                menuitem.children != null ?
                                    (<div key={i + "hover"} className="hover-box">
                                        <p key={i + "p"} className='link-button'>{menuitem.name} </p>
                                        <Divider type="vertical" style={{ borderColor: "#D4AF37", height: "30px" }} />
                                        <div key={i + "box"} className="expandable-box">
                                            {menuitem.children.map((child, j) => (
                                                <>
                                                    <p> <Link key={j} to={child.path} className='link-button'>{child.name} </Link></p>

                                                </>


                                            ))}
                                        </div>
                                    </div>) :
                                    (<div key={i + "box2"} className="hover-box">
                                        <Link key={i} to={menuitem.path} className='link-button' ><p >{menuitem.name} </p></Link>
                                        <Divider type="vertical" style={{ borderColor: "#D4AF37", height: "30px" }} />
                                    </div>)

                            ))}


                        </div>
                        <Button
                            type="text"
                            style={{ background: "#D4AF37", width: 50, height: 50 }}
                            icon={isExpanded ? <MenuFoldOutlined style={{ fontSize: '34px', padding: '10px' }} /> : <MenuUnfoldOutlined style={{ fontSize: '34px' }} />}
                            onClick={toggleMenu}
                        />

                    </div>

                    <div className="businesshour">
                        <p ><ClockCircleOutlined /> Business Hours:
                            <br /> 9:30AM - 5:30PM
                        </p>
                        <p > &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<PhoneFilled /> Phone:
                            <br /> +977 015922895 |  +977 9764399066 |  +977 9764399067
                        </p>
                    </div>
                </div>

                {isExpanded && <div className="overlay" onClick={toggleMenu}></div>}
                <div className={`side-menu ${isExpanded ? "open" : ""}`}>
                    {ROUTELIST.map((menuitem, i) => (
                        <div key={menuitem.id} className="item">
                            <div className="side-menuitem"
                                onClick={() => handleDivClick(i)}>

                                {!menuitem.path ? <div className="menu">{menuitem.name}</div> : (<Link key={i} to={menuitem.path} className="menu"><div className="menu">{menuitem.name}</div></Link>)}


                            </div>
                            {menuitem.children && openDiv === i && (
                                <div className="side-menuitem-child" >
                                    {menuitem.children.map((childContent, i) => (

                                        <Link key={i} to={childContent.path} className="menu"><div className="menu-child" >{childContent.name}</div></Link>



                                    ))}
                                </div>
                            )}
                        </div>



                        // (<div key={i + "side-menu-items"} >
                        //         <div  className="main-box" onClick={() => handleDivClick(i)}>
                        //         {menuitem.name}
                        //         </div>

                        //         {menuitem.children.map((child, j) => (
                        //             <div className="side-menu-items-child">

                        //                 <p><Link key={j} to={child.path} className='item'>{child.name}</Link></p>
                        //             </div>
                        //         ))}

                        //     </div>) :
                        //     (<div key={i + "box2"} className="side-menu-items">
                        //         <Link key={i} to={menuitem.path} className='item' ><p >{menuitem.name}</p></Link>

                        //     </div>)

                    ))}

                </div>

                <div className="playground">
                    <Routes>
                        {[...ROUTELIST, {
                            id: 7,
                            path: "/project/:name",
                            element: <ProjectsDetails />,
                            name: "Project Details"
                        },].map((page, i) => (
                            page.children == null ?
                                (
                                    <Route key={i} path={page.path} element={page.element} ></Route>

                                ) :
                                (
                                    <>
                                        {page.children.map((child, j) => (
                                            <Route key={j} path={child.path} element={child.element} ></Route>
                                        ))}

                                    </>
                                )
                        ))}
                        <Route path={"/testimonials"} element={<TestimonialPage />}></Route>
                        <Route path={"/profile"} element={<Profile />}></Route>

                    </Routes>
                </div>
            </Router>
            <Footer className="footer" style={{ textAlign: 'center' }}>
                <b style={{ fontSize: 16 }}>Brahma Jyoti Holdings Limited ©2024</b>
                <div style={{ margin: '5px 5px 10px 0' }}>
                    <MailOutlined /> <a href="mailto:brahmajyoti01@gmail.com">brahmajyoti01@gmail.com </a> | <a href="mailto:contactbrahmajyoti@gmail.com"> contactbrahmajyoti@gmail.com</a>
                </div>
                <div >
                    <a className="social-media-links" href="https://www.facebook.com/people/Brahma-Jyoti-Holdings/61565656058735/?mibextid=ZbWKwL"><FacebookFilled />Facebook | </a>
                    <a className="social-media-links" href="https://www.instagram.com/brahmagroup04/" ><InstagramFilled /> Instagram | </a>
                    <a className="social-media-links" href="https://wa.me/message/HXXBH2BI6B7GD1"><WhatsAppOutlined /> Whatsapp | </a>
                    <a className="social-media-links" href="https://www.linkedin.com/public-profile/settings?trk=d_flagship3_profile_self_view_public_profile"><LinkedinFilled /> Linkedin | </a>
                    <a className="social-media-links" href="https://x.com/brahmagroup01"><XOutlined /> X |</a>
                    <a className="social-media-links" href="https://www.tiktok.com/@brahmagroup03?is_from_webapp=1&sender_device=pc">  <TikTokFilled /> Tiktok</a>
                </div>

            </Footer>
        </div>
    )
}


export default RouterHandler;